(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("RPGDialogue", [], factory);
	else if(typeof exports === 'object')
		exports["RPGDialogue"] = factory();
	else
		root["RPGDialogue"] = factory();
})(self, () => {
return 